import React, {FormEvent, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {SelectChangeEvent} from "@mui/material/Select/SelectInput";
import CustomTextField from "../custom-text-field/custom-text-field";
import CustomButton from "../custom-button/custom-button";
import CustomButtonGroup from "../custom-button-group/custom-button-group";
import CustomRow from "../custom-row/custom-row";
import SelectOption from "../select-option/select-option";
import ForeignKey from "../foreign-key/foreign-key";
import {changePageTitle, setAlert} from "../redux/actions";
import {DateUtil} from "../util/date-util";
import {WalletService} from "./wallet.service";
import {Wallet} from "./wallet";
import {ManualEntry} from "./manual-entry";

const today = () => DateUtil.toJavaSqlDate(new Date()) || '';

const entryTypes = [
    {value: 'ENTRY', description: 'Entrada'},
    {value: 'EXIT', description: 'Saída'}
];

const WalletManualEntry = () => {
    const dispatch = useDispatch();
    const [wallet, setWallet] = useState<Wallet | null>(null);
    const [date, setDate] = useState(today());
    const [amount, setAmount] = useState('');
    const [type, setType] = useState<ManualEntry['type'] | ''>('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        dispatch(changePageTitle("Lançamento manual"));
    }, [dispatch]);

    const onChangeWallet = async (id: number) => {
        setWallet({id: id});
        if (id) {
            onSelectWallet(await WalletService.findOne(id));
        }
    }

    const onSelectWallet = (selected: Wallet) => {
        if (selected?.id) {
            setWallet(selected);
        }
    }

    const clearForm = () => {
        setAmount('');
        setType('');
        setDescription('');
    }

    const submit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        if (!wallet?.id || !type) {
            return;
        }
        const entry: ManualEntry = {
            walletId: wallet.id,
            date: date,
            amount: parseFloat(amount),
            type: type,
            description: description
        };
        WalletService.manualEntry(entry).then(() => {
            clearForm();
            dispatch(setAlert({
                show: true,
                message: 'Lançamento manual realizado com sucesso',
                severity: 'success'
            }));
        }, (error) => {
            dispatch(setAlert({
                show: true,
                message: 'Erro ao realizar lançamento manual - ' + error.response.data.message,
                severity: 'error'
            }));
        });
    }

    return (
        <form onSubmit={submit}>
            <CustomRow>
                <ForeignKey autoFocus fullWidth required label="Conta" value={wallet} fieldKey={'id'}
                            fieldDescription={'descricao'} labelDescription='Descrição' onChange={onChangeWallet}
                            onSelect={onSelectWallet} findAll={WalletService.findAll}
                            dataColumnNames={['ID', 'Descrição']} dataColumns={['id', 'descricao']}
                            dataTypes={['number', 'text']}/>
            </CustomRow>
            <CustomRow>
                <CustomTextField type="date" fullWidth required label="Data" value={date}
                                 onChange={(event) => setDate(event.target.value)}
                                 InputLabelProps={{shrink: true}} InputProps={{inputProps: {max: today()}}}/>
                <CustomTextField type="number" fullWidth required label="Valor (R$)" value={amount}
                                 onChange={(event) => setAmount(event.target.value)}
                                 InputProps={{inputProps: {min: 0.01, step: "any"}}}/>
                <SelectOption fullWidth required label="Tipo" value={type} items={entryTypes}
                              itemValue="value" itemDescription="description"
                              onChange={(event: SelectChangeEvent) => setType(event.target.value as ManualEntry['type'])}/>
            </CustomRow>
            <CustomTextField fullWidth required label="Descrição" value={description}
                             onChange={(event) => setDescription(event.target.value)}
                             InputProps={{inputProps: {maxLength: 200}}}/>
            <CustomButtonGroup>
                <CustomButton color="primary" type="submit">Lançar</CustomButton>
            </CustomButtonGroup>
        </form>
    );
}

export default React.memo(WalletManualEntry);
